import React, { useState } from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import classnames from "classnames"

import Search from "./search"
import DFDLongLogo from "../images/DFDLongLogo2.png"
import DFDLogo from "../images/dfd.png"

const NavLink = ({ children, ...props }) => (
  <Link className="mr-1 p-2 hover:text-gray-900" {...props}>
    {children}
  </Link>
)

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false)
  const toggleMenu = () => setShowMenu(!showMenu)

  return (
    <nav className="border-b border-gray-300 fixed top-0 inset-x-0 z-10 bg-white">
      <div className="max-w-screen-xl mx-auto px-2 flex flex-col lg:flex-row">
        <div className="flex flex-grow">
          <Link className="px-2 sm:px-3 flex flex-none" to="/">
            <img
              src={DFDLongLogo}
              alt="DFD Logo"
              className="self-center w-56 h-auto hidden sm:inline"
            />
            <img
              src={DFDLogo}
              alt="DFD Logo"
              className="self-center h-8 w-8 sm:hidden"
            />
          </Link>

          <div className="flex flex-grow m-2 sm:mx-8 md:mx-12 xl:mx-16">
            <Search />
          </div>

          <button
            onClick={toggleMenu}
            className="flex-shrink-0 px-2 sm:px-3 lg:hidden"
          >
            <FontAwesomeIcon
              fixedWidth
              size="lg"
              icon={showMenu ? faTimes : faBars}
              className="text-gray-700"
            />
          </button>
        </div>

        <div
          className={classnames(
            "text-md flex-none text-gray-600 flex text-left flex-shrink-0 flex-col mb-2",
            { hidden: !showMenu },
            "lg:flex lg:flex-row lg:items-center lg:mb-0"
          )}
        >
          <NavLink to="/contribute">About</NavLink>
          <NavLink to="/organizations">Organizations</NavLink>
          <NavLink to="https://blog.templesofindia.org" target='_blank'>Temples Blog</NavLink>
        </div>
      </div>
    </nav>
  )
}

export default Navbar